import { Data, FormProps } from "@/types";
import { useTranslation } from "react-i18next";
import { useContext } from "react";
import AppContext from "@/context/appContext";
import classNames from "classnames";
import Input from "./input";

export default function DesktopInputs({
  formDetails,
  setErrorMessage,
  inputErrors,
}: FormProps) {
  const { t } = useTranslation("main");
  const { inputData, setInputData } = useContext(AppContext);

  return (
    <div className="flex flex-2 flex-col">
      <table className="text-xs">
        <thead>
          <tr>
            <th></th>
            <th className="text-sm">
              {t("strategic_projects")}
              <br />
              {t("up_to")}
            </th>
            <th className="text-sm">
              {t("major_projects")}
              <br />
              {t("over")}
            </th>
          </tr>
        </thead>
        <tbody>
          {formDetails.map(
            (
              {
                title,
                placeholder,
                border,
                inputId1,
                inputId2,
                errorsType1,
                errorsType2,
              },
              i,
            ) => (
              <tr
                key={title}
                className={classNames(border && "border-b-2 border-cd-purple")}
              >
                <td>
                  <label className="text-sm font-semibold" htmlFor={inputId1}>
                    {title}
                  </label>
                </td>
                <td>
                  <div className="relative mb-4 mt-4 flex justify-center">
                    <Input
                      onChange={(e) => {
                        const value = e.target.valueAsNumber;
                        if (value && value < 1) {
                          setErrorMessage(
                            i,
                            errorsType1,
                            t("input_error.at_least_1"),
                          );
                        } else if (value && !Number.isInteger(value)) {
                          setErrorMessage(
                            i,
                            errorsType1,
                            t("input_error.whole_number"),
                          );
                        } else {
                          setInputData &&
                            setInputData({
                              ...inputData,
                              [inputId1]: value,
                            });
                          setErrorMessage(i, errorsType1, "");
                        }
                      }}
                      onBlur={(e) => {
                        if (!e.target.value) {
                          setErrorMessage(
                            i,
                            errorsType1,
                            t("input_error.required"),
                          );
                        }
                      }}
                      variant={inputErrors[errorsType1][i] ? "error" : "normal"}
                      placeholder={placeholder && placeholder}
                      id={inputId1}
                      value={
                        (inputData && inputData[inputId1 as keyof Data]) || ""
                      }
                      type="number"
                      inputMode="numeric"
                      min="1"
                      aria-invalid={
                        inputErrors[errorsType1][i] ? "true" : "false"
                      }
                    />
                    {inputErrors[errorsType1][i] && (
                      <p
                        className="absolute -bottom-2 right-5 rounded-lg border border-red-600 bg-white px-1 py-[0.1rem] text-[1rem] text-red-600"
                        role="alert"
                      >
                        {inputErrors[errorsType1][i]}
                      </p>
                    )}
                  </div>
                </td>
                <td>
                  <div className="relative flex justify-center">
                    <Input
                      onChange={(e) => {
                        const value = e.target.valueAsNumber;
                        if (value && value < 1) {
                          setErrorMessage(
                            i,
                            errorsType2,
                            t("input_error.at_least_1"),
                          );
                        } else if (value && !Number.isInteger(value)) {
                          setErrorMessage(
                            i,
                            errorsType2,
                            t("input_error.whole_number"),
                          );
                        } else {
                          setInputData &&
                            setInputData({
                              ...inputData,
                              [inputId2]: value,
                            });
                          setErrorMessage(i, errorsType2, "");
                        }
                      }}
                      onBlur={(e) => {
                        if (!e.target.value) {
                          setErrorMessage(
                            i,
                            errorsType2,
                            t("input_error.required"),
                          );
                        }
                      }}
                      variant={inputErrors[errorsType2][i] ? "error" : "normal"}
                      placeholder={placeholder && placeholder}
                      id={inputId2}
                      value={
                        (inputData && inputData[inputId2 as keyof Data]) || ""
                      }
                      type="number"
                      inputMode="numeric"
                      min="1"
                      aria-invalid={
                        inputErrors[errorsType2][i] ? "true" : "false"
                      }
                    />
                    {inputErrors[errorsType2][i] && (
                      <p
                        className="absolute -bottom-2 right-5 rounded-lg border border-red-600 bg-white px-1 py-[0.1rem] text-[1rem] text-red-600"
                        role="alert"
                      >
                        {inputErrors[errorsType2][i]}
                      </p>
                    )}
                  </div>
                </td>
              </tr>
            ),
          )}
        </tbody>
      </table>
    </div>
  );
}
